import { render, staticRenderFns } from "./ViewNav.vue?vue&type=template&id=6133fa90&lang=pug&"
import script from "./ViewNav.vue?vue&type=script&lang=js&"
export * from "./ViewNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports